import React from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
type QuantityStepperProps = {
  value: number;
  onChange: (v: number) => void;
  min?: number;
  max?: number;
  label: string;
  size?: 'md' | 'lg';
};
export function QuantityStepper({
  value,
  onChange,
  min = 1,
  max = 99,
  label,
  size = 'md'
}: QuantityStepperProps) {
  const h = size === 'lg' ? 'h-14' : 'h-11';
  const w = size === 'lg' ? 'w-14' : 'w-11';
  const clamp = (n: number) => Math.max(min, Math.min(max, n));
  return <div className={`inline-flex items-stretch overflow-hidden rounded-md border mf-hairline bg-graphite ${h}`} data-id="element-929" data-mp="1833nuj71tkmc">
      <button type="button" onClick={() => onChange(clamp(value - 1))} disabled={value <= min} aria-label={`Decrease ${label}`} className={`${w} flex items-center justify-center text-titanium transition-colors duration-150 hover:bg-white/5 hover:text-white disabled:opacity-30`} data-id="element-930" data-mp="u3ltloazhf5l">
        <MinusIcon className="h-4 w-4" data-id="element-931" data-mp="3jtpg3i9dm8vs" />
      </button>
      <input type="number" inputMode="numeric" aria-label={label} value={value} min={min} max={max} onChange={e => {
      const n = parseInt(e.target.value, 10);
      if (!Number.isNaN(n)) onChange(clamp(n));
    }} className={`${size === 'lg' ? 'w-20 text-2xl' : 'w-14 text-lg'} border-x mf-hairline bg-transparent text-center font-display font-semibold text-white [appearance:textfield] focus:outline-none focus-visible:bg-white/5 [&::-webkit-inner-spin-button]:appearance-none`} data-id="element-932" data-mp="1dk7g5vfxt8rq" />
      <button type="button" onClick={() => onChange(clamp(value + 1))} disabled={value >= max} aria-label={`Increase ${label}`} className={`${w} flex items-center justify-center text-titanium transition-colors duration-150 hover:bg-white/5 hover:text-white disabled:opacity-30`} data-id="element-933" data-mp="1sg6xlwoxsl9j">
        <PlusIcon className="h-4 w-4" data-id="element-934" data-mp="2b914028hv525" />
      </button>
    </div>;
}